<template>
  <v-carousel
    v-if="quickAds.length"
    delimiter-icon="stop"
    hide-delimiters
    cycle
    height="180px"
    show-arrows-on-hover
    hide-delimiter-background
    next-icon="fad fa-chevron-right"
    prev-icon="fad fa-chevron-left"
    aria-label="Promotional banner carousel"
    role="region"
  >
    <v-carousel-item
      v-for="item in quickAds"
      :key="item.id"
      :value="item.title"
      :src="item.imageSrc"
      :ripple="true"
      class="landing-carsoul-item"
      role="button"
      tabindex="0"
      :aria-label="`${item.title}: ${item.subtitle}`"
      @click="goTo(item.link)"
      @keyup.enter="goTo(item.link)"
    >
      <v-layout
        class="landing-carsoul-content"
        column
        align-center
        justify-center
      >
        <div
          class="landing-carsoul-content-title"
          role="heading"
          aria-level="2"
          v-html="item.title"
        />
        <div
          class="landing-carsoul-content-date"
          role="text"
        >
          {{ item.subtitle }}
        </div>
        <span class="sr-only">
          {{ item.title }} - {{ item.subtitle }}
        </span>
        <v-divider
          role="presentation"
          aria-hidden="true"
        />
        <v-layout
          class="landing-carsoul-content-btns"
          align-center
          role="presentation"
        />
      </v-layout>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import quickAds from '@/constants/quick-ads';
import { mapGetters } from 'vuex'

export default {
    name: "AdCarousel",
    computed: {
        ...mapGetters(['isLogged']),

        quickAds() {
            return (this.isLogged ? quickAds.logged : quickAds.guest).map((item) => ({
                ...item,
                title: this.$t(item.title),
                subtitle: this.$t(item.subtitle),
            }));
        },
    },
    methods: {
      goTo(link) {
        window.open(link, '_blank');
      }
    }
  };
  </script>

<style scoped>
/* Component-specific styles */
</style>
